import type { TitleData } from '../types.js';

/**
 * 排序字段数据
 */
export const sortData: TitleData = {
  'f,xb': ['几爸爸', '几爸', '几爹'],
  'f,xb,w': ['几妈妈', '几妈', '几娘'],
  'f,f,xb': ['几爷爷', '几大爷', '几嗲', '几爷', '几公'],
  'f,f,xb,w': ['几奶奶', '几大娘', '几奶', '几婆'],
  'm,f,xb': ['几外公', '几姥爷', '几外爷'],
  'm,f,xb,w': ['几外婆', '几姥姥', '几姥奶', '几外奶', '几姥'],
};

export default sortData;
